import { render, staticRenderFns } from "./ProfitsList.vue?vue&type=template&id=cb1f5af4&scoped=true&"
import script from "./ProfitsList.vue?vue&type=script&lang=js&"
export * from "./ProfitsList.vue?vue&type=script&lang=js&"
import style0 from "./ProfitsList.vue?vue&type=style&index=0&id=cb1f5af4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1f5af4",
  null
  
)

export default component.exports